import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  gridSizeMdLg4,
  gridSizeMdLg6,
  newGrupoActivoSchema,
} from "@/shared";
import {
  CustomNumberTextField,
  CustomTextField,
  SampleCheckbox,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { GrupoActivo } from "@/shared/interfaces/erp/activos";
import { useCreateGrupoActivo, useUpdateGrupoActivo } from "@/shared/actions/erp";


const returnUrlGa = "/activos/grupo-activos";

export interface SaveGrupoActivosProps {
  titlePage: string;
  editGrupoActivos?: GrupoActivo;
}

type SaveFormData = {
  id_grupo_activo?: string;
  numero_referencia?: string;
  codigo: string;
  nombre: string;
  porcentaje_depreciacion: string;
  estado: boolean;
  meses_deprecacion: number;
  valor_deprecacion_mensual: string;
  valor_deprecacion_anual: string;
  anios_deprecacion: number;
  vida_util: number;
  valor_residual: string;
  valor_deprecacion_diaria: string;
};

const SaveGrupoActivos: React.FC<SaveGrupoActivosProps> = ({
  titlePage,
  editGrupoActivos,
}) => {
  const navigate = useNavigate();

  ///* local state
  const [shrink, setShrink] = useState(false);



  const setAlert = useUiStore(s => s.setAlert);



  ///* fetch data
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newGrupoActivoSchema) as any,
    defaultValues: {
      estado: false,
    }
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;
  ///* mutations
  const createGrupoActivosMutation = useCreateGrupoActivo({ navigate, returnUrl: returnUrlGa });
  const updateGrupoActivosMutation = useUpdateGrupoActivo({ navigate, returnUrl: returnUrlGa });
  ///* handlers
  const onSave = async () => {
    if (!isValid) return;
    if (editGrupoActivos?.id_grupo_activo) {
      return updateGrupoActivosMutation.mutate({
        id: editGrupoActivos.id_grupo_activo,
        data: form.getValues() as any,
      });
    }
    return createGrupoActivosMutation.mutate(form.getValues() as any);
  }
  useEffect(() => {
    reset({
      ...editGrupoActivos,
    } as any);
    setShrink(true);
  }, [editGrupoActivos, reset]);



  return (
    <>
      <SingleTableBoxScene
        title={titlePage}
        //title={'Grupo Activo'}
        enableBackBtn={true}
        backPageUrl="/activos/grupo-activos"
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, () => {
          setAlert(true, 'Faltan campos por llenar', 'error');
        })}
      >

        <Grid container spacing={3}>
          <CustomTextField
            name="codigo"
            label="codigo"
            control={form.control}
            defaultValue={form.getValues().codigo || ""}
            error={errors.codigo}
            helperText={errors.codigo?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            name="nombre"
            label="nombre"
            control={form.control}
            defaultValue={form.getValues().nombre || ""}
            error={errors.nombre}
            helperText={errors.nombre?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          <CustomNumberTextField
            label="porcentaje depreciacion"
            name="porcentaje_depreciacion"
            //register={register('porcentaje_depreciacion')}
            error={errors.porcentaje_depreciacion}
            helperText={errors.porcentaje_depreciacion?.message}
            shrink={shrink}
            min={0}
            max={100}
            size={gridSizeMdLg4}
            control={form.control}
            defaultValue={form.getValues().porcentaje_depreciacion || ''}  
          />
          <CustomNumberTextField
            label="meses depreciacion"
            name='meses_deprecacion'
            //register={register('meses_deprecacion')}
            error={errors.meses_deprecacion}
            helperText={errors.meses_deprecacion?.message}
            shrink={shrink}
            min={0}
            max={100}
            control={form.control}
            defaultValue={form.getValues().meses_deprecacion || ''}
            size={gridSizeMdLg4}
          />
          <CustomNumberTextField
            label="Valor mensual depreciacion"
            name="valor_deprecacion_mensual"
            //register={register('valor_deprecacion_mensual')}
            error={errors.valor_deprecacion_mensual}
            helperText={errors.valor_deprecacion_mensual?.message}
            shrink={shrink}
            min={0}
            max={100}
            size={gridSizeMdLg4}
            control={form.control}
            defaultValue={form.getValues().valor_deprecacion_mensual || ''}
          />
          <CustomNumberTextField
            label="Valor anual depreciacion"
            name='valor_deprecacion_anual'
            ///register={register('valor_deprecacion_anual')}
            error={errors.valor_deprecacion_anual}
            helperText={errors.valor_deprecacion_anual?.message}
            shrink={shrink}
            min={0}
            max={100}
            control={form.control}
            defaultValue={form.getValues().valor_deprecacion_anual || ''}
            size={gridSizeMdLg4}
          />
          <CustomNumberTextField
            label="Años depreciacion"
            name="anios_deprecacion"
            ///register={register('anios_deprecacion')}
            error={errors.anios_deprecacion}
            helperText={errors.anios_deprecacion?.message}
            shrink={shrink}
            min={0}
            max={100}
            control={form.control}
            defaultValue={form.getValues().anios_deprecacion  || ''}
            size={gridSizeMdLg4}
          />
          <CustomNumberTextField
            label="Vida util"
            name="vida_util"
            ///register={register('vida_util')}
            error={errors.vida_util}
            helperText={errors.vida_util?.message}
            shrink={shrink}
            min={0}
            max={100}
            control={form.control}
            defaultValue={form.getValues().vida_util || ''}  
            size={gridSizeMdLg4}
          />
          <CustomNumberTextField
            label="Valor residual"
            name="valor_residual"
            ///register={register('valor_residual')}
            error={errors.valor_residual}
            helperText={errors.valor_residual?.message}
            shrink={shrink}
            min={0}
            max={100}
            control= {form.control}
            defaultValue={form.getValues().valor_residual || ''}
            size={gridSizeMdLg4}
          />
          <CustomNumberTextField
            label="Valor deprecacion diaria"
            name = "valor_deprecacion_diaria"
            ///register={register('valor_deprecacion_diaria')}
            error={errors.valor_deprecacion_diaria}
            helperText={errors.valor_deprecacion_diaria?.message}
            shrink={shrink}
            min={0}
            max={100}
            control={form.control}
            defaultValue={form.getValues().valor_deprecacion_diaria ||''} 
            size={gridSizeMdLg4}
          />
          <SampleCheckbox
            label="Estado"
            name="estado"
            control={form.control}
            defaultValue={!!form.getValues().estado}
            isState
            size={gridSizeMdLg6}
          />
        </Grid>
      </SingleTableBoxScene>
    </>
  );
};

export default SaveGrupoActivos;
